import styles from "./style.module.scss";
import Diving from "src/assets/diving.jpg";
import { Link } from "react-router-dom";

export const DivingSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <div className={styles.imageBox}>
          <img src={Diving} alt="diving" />
          <p>Diving</p>
        </div>

        <h3>ダイビングで四季のある海の中へ</h3>
        <p className={styles.description}>
          海の中の景色は、四季とともに驚くほど変化します。この体験では、南国にはない季節ごとに表情を変える海の魅力を間近で感じることができます。慣れてくると、普段は見ることができない牡蠣やホタテの養殖棚も海の中から観察可能。その光景はまさに水中のアートのような美しさです。
        </p>

        <Link to="/activity#diving" className={styles.link}>
          more
        </Link>
      </div>
    </section>
  );
};
